import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AlertController, LoadingController } from 'ionic-angular';
import { Observable } from  'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { CategoriesProvider } from '../categories/categories';
import { KeywordProvider } from '../keyword/keyword';
import { IndicationProvider } from '../indication/indication';
import { LocalfileProvider } from '../localfile/localfile';
import { AssetProvider } from '../asset/asset';
import { tap, catchError } from 'rxjs/operators';
import { SynchroProgress } from '../../interfaces/synchro-progress.model';

import { StorageProvider } from '../storage/storage';
import { TranslateService } from '@ngx-translate/core';

import { HelperProvider } from '../helper/helper';
import { UserInfo } from '../../interfaces/user-info.model';
import { UserInformationProvider } from '../user-information/user-information';
import { ENV } from '@app/env';


@Injectable()
export class SynchroProvider {

  synchroDateBS: Subject<Date>;
  synchroDate: Date;
  startSyncDate: string;
  synchroList: any;
  progress: SynchroProgress = {
    InProgress: false,
    Current: 0,
    Total: 0,
    Finished: false,
    Error: false,
    ErrorDetails: null
  };
  loading: any;
  userInformation: UserInfo;

  wsUrl: string = ENV.wsUrl+'STSService/FFOService.svc/';

  constructor(public http: HttpClient,
    public storage: Storage,
    public helperService: HelperProvider,
    public categoriesService: CategoriesProvider,
    public assetService: AssetProvider,
    public localfileService: LocalfileProvider,
    public keywordService: KeywordProvider,
    public indicationService: IndicationProvider,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public storageService: StorageProvider,
    public translate: TranslateService,
    public userInfoService: UserInformationProvider) 
    {
      this.synchroDateBS = new Subject<Date>();
      this.getSynchroDate().then((date:Date) => {
        this.synchroDateBS.next(date);
      });
      
    }

  getSynchro(syncDate): Observable<any> {
    return this.http.get(this.wsUrl+'Synchro?syncDate='+syncDate, { withCredentials: true})
    .pipe(
      tap(synchroList => this.synchroList = synchroList),
      catchError(this.handleError)
    )
  }

  getSynchroDate(){
    return new Promise((resolve, reject) => {
      this.storage.get("syncDate").then((data:Date) => {
        this.synchroDate = data;
        resolve(data);
      })
    });
  }

  setSynchroDate(syncDate) {
    this.synchroDateBS.next(syncDate);
    return this.storage.set("syncDate", syncDate);
  }

  synchroAllData(): Observable<SynchroProgress>{
    let subject = new Subject<SynchroProgress>();
    this.progress.InProgress = true;
    this.progress.Finished = false;
    this.progress.Error = false;

    this.synchroAllLists().then(data => {
      let synchroListAssets = this.synchroList.Assets;

      if((synchroListAssets.Updated.length > 0) || (synchroListAssets.Added.length > 0) || (synchroListAssets.Deleted.length > 0)) {
        
        if((synchroListAssets.Updated.length > 0) || (synchroListAssets.Added.length > 0)) {
          let progressTotal = synchroListAssets.Updated.length + synchroListAssets.Added.length;
          this.progress.Current = 0;
          this.progress.Total = progressTotal;
        } 
        
        subject.next(this.progress);
        this.assetService.synchroAssetsFile(subject, this.progress, synchroListAssets);
      } else {
        this.progress.Finished = true;
        subject.next(this.progress);
        subject.complete();
      }
    });

    return subject.asObservable();
  }

  synchroAllLists() {
    return new Promise((resolve, reject) => {
      let p1 = this.categoriesService.updateCategoryList(this.synchroList.Categories);
      let p2 = this.assetService.updateAssetList(this.synchroList.Assets);
      let p3 = this.indicationService.updateIndicationList(this.synchroList.Indications);
      let p4 = this.keywordService.updateKeywordList(this.synchroList.Keywords);
      let p5 = this.localfileService.updateLocalfileList(this.synchroList.Assets);
      Promise.all([p1, p2, p3, p4, p5]).then(data => { 
        resolve(data);
      });
    });
  }

  checkSynchroListsNotEmpty(synchroList){
    let found = false;

    for(var obj in synchroList){
      let prop = synchroList[obj];
      if(typeof prop == "object") {
        if(prop.Deleted.length > 0 || prop.Added.length > 0 || prop.Updated.length > 0){
          found = true;
          break;
        }
      }
    }
    return found;
  }

  startSynchro(){
    return new Promise((resolve, reject) => {
      this.getSynchroDate().then(() => {
        this.getSynchro(this.synchroDate).subscribe(resSynchroList => {
          this.userInfoService.setUserActions();
          if(this.synchroList.ResetUser) {
            resolve('resetUser');
          } else {
            let found = this.checkSynchroListsNotEmpty(this.synchroList);
            if(found){
              resolve('startSynchro');
            } else {
              resolve('noNewContent');
            }
          }
        });
      });
    });
  }

  //[VP - 11/04/2019] Seems like it is not used anymore
  // setUserInfo(){
  //   return this.userInfoService.setUserInformation();
  // }
  
  currentSyncDate(){
    return this.synchroDateBS.asObservable();
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened; please try again later.');
  };

}



// WEBPACK FOOTER //
// ./src/providers/synchro/synchro.ts